export default __webpack_public_path__ + "static/media/portfolio-74.2390565a.jpg";